import React, { useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { ArticleConstants } from '../../adapters/helpers/Constants';
import { AssetProps } from '../../types';

interface Article {
    fields?: {
        contentType?: string;
        name?: string;
        pageMapping?: string;
        slug?: {
            fields?: {
                slug?: string;
                disabled?: boolean;
                searchable?: boolean;
                alternativeUrlList?: string[];
                contentType?: string;
            };
        };
        thumbnailImage?: {
            fields?: {
                name?: string;
                alternateText?: string;
                imageRendition?: object;
                isPreload?: boolean;
                asset?: AssetProps;
            };
        };
        title?: string;
        readTime?: string;
    };
    metadata?: {
        tags?: any[];
        concepts?: any[];
    };
    sys?: {
        space?: object;
        type?: string;
        id?: string;
        contentType?: object;
        revision?: number;
    };
}

interface ArticleAdditionalReadingProps {
    articles?: Article[];
    isMobile?: boolean;
    rightArrowIconArticle?: {
        fields?: {
            asset?: AssetProps;
        };
    };
    leftArrowIconArticle?: {
        fields?: {
            asset?: AssetProps;
        };
    };
}

const ArticleAdditionalReading: React.FC<ArticleAdditionalReadingProps> = ({
    articles,
    isMobile,
    rightArrowIconArticle,
    leftArrowIconArticle,
}) => {
    const swiperRef = useRef<SwiperCore | null>(null);

    const handleNext = () => {
        swiperRef.current?.slideNext();
    };

    const handlePrev = () => {
        swiperRef.current?.slidePrev();
    };

    const renderArticleList = () => {
        return articles?.map((article, i) => {
            const contentThumbnail = article?.fields?.thumbnailImage?.fields?.asset?.fields?.file;
            return (
                <li className="additional-reading_item px-0 md:px-1 flex md:inline-block justify-center items-center" key={i}>
                    <a className="additional-reading_item-link" href={article?.fields?.slug?.fields?.slug}>
                        <div className="additional-reading_item-image  w-302 h-167 md:w-250 md:h-138">
                            {!!contentThumbnail && (
                                <img
                                    className="additional-reading__item-img w-302 h-167 md:w-250 md:h-138 object-cover"
                                    alt={`${article?.fields?.title}`}
                                    src={`https:${contentThumbnail?.url}`}
                                    width={302}
                                    height={167}
                                />
                            )}
                        </div>
                        <div className="additional-reading_item-info w-302 md:w-250">
                            <div className="additional-reading_item-title text-revamp_blueText font-regular text-lg md:text-15 leading-30 md:leading-20 px-1h py-1">
                                {article?.fields?.title}
                            </div>
                            {!!article?.fields?.readTime && (
                                <div className="additional-reading__item-time">
                                    {article?.fields?.readTime} {ArticleConstants?.minReadingTime}
                                </div>
                            )}
                        </div>
                    </a>
                </li>
            );
        });
    };

    return (
        <div className={`article-additional-reading ${isMobile ? 'mobile w-full md:px-0 pb-4 md:pb-1' : 'desktop w-full px-0 md:px-3'}`}>
            <div className={isMobile ? 'px-2h' : ''}>
            <h2
                className={
                    isMobile
                        ? 'text-2xl leading-34 font-semi-bold text-revamp_blueText pb-1 border-b border-solid border-black mb-8'
                        : 'additional-reading_heading font-semi-bold text-26 leading-30 !text-revamp_grey_text md:text-revamp_blueText pb-2'
                }
            >{ArticleConstants?.relatedArticleTitle}</h2>
            </div>   
            {isMobile ? (
                <div className="swiper-container flex items-center justify-center">
                    <button className="custom-prev-button relative left-3 top-4hless z-99" onClick={handlePrev}>
                        <img
                            src={`https:${leftArrowIconArticle?.fields?.asset?.fields?.file?.url}`}
                            alt={ArticleConstants?.PreviousArrowImgAltText}
                            className='w-10 h-6'
                            width={10}
                            height={6}
                        />
                    </button>
                    <Swiper
                        className=""
                        spaceBetween={10}
                        slidesPerView={1}
                        pagination={false}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                    >
                        {articles?.map((article, i) => (
                            <SwiperSlide key={i}>{renderArticleList()?.[i]}</SwiperSlide>
                        ))}
                    </Swiper>
                    <button className="custom-next-button relative right-3 top-4hless z-99" onClick={handleNext}>
                        <img
                            src={`https:${rightArrowIconArticle?.fields?.asset?.fields?.file?.url}`}
                            alt={ArticleConstants?.NextArrowImgAltText}
                            className='w-10 h-6'
                            width={10}
                            height={6}
                        />
                    </button>
                </div>
            ) : (
                <ul className="additional-reading_list flex w-full flex-wrap justify-center lg:justify-start">
                    {renderArticleList()}
                </ul>
            )}
        </div>
    );
};

export default ArticleAdditionalReading;